import React from 'react';
import _ from 'lodash';
import TabContainer from '../../../../common/components/tab/containers/tab.containers';
import NexusARecordBasicDetailsComponent from './nexus-a-record-basic-details.component';

function NexusARecordComponent({
    id, back, handleFormSubmit, handleInnerFormChange, TemplateGroupEntityType, selectedNexusARecords,templates, PolicyOwnerType, accountTypesListLoading, accountListLoading, accountsList, accountTypesList,
    entityTypeList, nexusARecordTypeList
}: any) {

    const tabItems = [
        {
            id: 1,
            title: 'Nexus A Records Details',
            component: <NexusARecordBasicDetailsComponent
                handleInnerFormChange={handleInnerFormChange}
                selectedNexusARecords={selectedNexusARecords}
                entityTypeList={entityTypeList}
                nexusARecordTypeList={nexusARecordTypeList}
                PolicyOwnerType={PolicyOwnerType}
                accountTypesList={accountTypesList}
                accountTypesListLoading={accountTypesListLoading}
                accountsList={accountsList}
                accountListLoading={accountListLoading}
                TemplateGroupEntityType={TemplateGroupEntityType}
                templates={templates}


            />,
            isVisible: true,
        },
    ]

    return (
        <>
            <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">

                <TabContainer tabItems={tabItems} />

                <div className='flex w-full justify-end items-end'>
                    <button
                        onClick={back}
                        type='button'
                        className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                    >
                        Back
                    </button>
                    <button
                        className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                        onClick={handleFormSubmit}
                        type="submit"
                    >
                        Save
                    </button>
                </div>
            </div>
        </>
    );
}

export default NexusARecordComponent;
